import { Configuration, PopupRequest } from '@azure/msal-browser';

// Hardcoded fallbacks match the known SPA app registration. CRA inlines
// REACT_APP_* at BUILD time; if a build runs from outside web/ (so web/.env is
// never read) these keep MSAL configured with a real clientId/tenant instead of
// shipping an empty client_id — which AAD rejects with AADSTS900144.
const AZURE_CLIENT_ID = '0d41cd70-b5b4-4ff1-a706-41d14867adc0';
const AZURE_TENANT_ID = 'b9c7a6df-7986-4867-9d0a-cb21002d8f01';

const clientId = process.env.REACT_APP_AZURE_CLIENT_ID || AZURE_CLIENT_ID;
const tenantId = process.env.REACT_APP_AZURE_TENANT_ID || AZURE_TENANT_ID;
const authorityUrl = 'https://login.microsoftonline.com/' + tenantId;

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: authorityUrl,
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
  },
};

// Scope for acquiring an access token to call our own Functions API.
// Matches the "Expose an API" scope on the app registration; the backend
// validates this token's signature + audience and reads the user's app role.
const apiClientId = clientId;
const apiScope = `api://${apiClientId}/access_as_user`;

export const apiTokenRequest = {
  scopes: [apiScope],
};

// Scope for reading the org directory from Microsoft Graph (client-side user
// picker). Requires the SPA app registration to have delegated
// `User.ReadBasic.All` with tenant admin consent granted; without consent the
// silent/popup token acquisition fails and graph.ts falls back to [] (no error
// surfaced). Audience here is Microsoft Graph, NOT our Functions API.
export const graphTokenRequest = {
  scopes: ['User.ReadBasic.All'],
};

// Scope for reading this app's APP-ROLE ASSIGNMENTS from Microsoft Graph, so the
// View-as / Assign pickers can be limited to people who actually hold a role
// (SALES / MANAGER / ADMIN). Reading servicePrincipals + appRoleAssignedTo needs
// Directory.Read.All (delegated, admin-consent). If consent isn't granted the
// role lookup fails and the pickers fall back to the full org directory.
export const graphDirectoryRequest = {
  scopes: ['Directory.Read.All'],
};

// Request the API scope AND the Graph scopes at login, so they're consented up
// front and cached — acquireTokenSilent then succeeds without an iframe/popup
// (the picker's directory + role fetches are silent-only). With tenant admin
// consent granted, this adds no per-user prompt.
export const loginRequest: PopupRequest = {
  scopes: ['User.Read', 'User.ReadBasic.All', 'Directory.Read.All', 'openid', 'profile', 'email', apiScope],
};

export const apiConfig = {
  baseUrl: process.env.REACT_APP_API_URL || 'https://func-commlogix-sandbox.azurewebsites.net/api',
  signalRUrl: process.env.REACT_APP_SIGNALR_URL || 'https://signalr-saleslogix.service.signalr.net',
};
